export default function HeroSection() {
  return (
    <section className="relative h-[60vh] min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full">
        <iframe
          src="https://www.youtube.com/embed/Nq4ucwm6Jx4?autoplay=1&mute=1&loop=1&playlist=Nq4ucwm6Jx4&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] h-[56.25vw] min-h-full min-w-full -translate-x-1/2 -translate-y-1/2"
          allow="autoplay; encrypted-media"
          title="Background video"
          style={{ border: 'none', pointerEvents: 'none' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <p className="text-sm sm:text-base lg:text-lg mb-4 sm:mb-6 font-light">
              「音が出ない」「画面が映らない」。その不安、今日で終わります。
            </p>
            <h1 className="text-xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold mb-6 sm:mb-8 leading-tight">
              配信トラブル、対処法は30秒で見つかる。
              <br />
              2人いれば、企業配信は始められる。
            </h1>
            <div className="flex flex-wrap gap-3 sm:gap-4">
              <a
                href="/blog"
                className="inline-flex items-center px-6 sm:px-8 py-3 sm:py-4 bg-orange-500 text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                トラブル解決ガイドを見る
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="/contact"
                className="inline-flex items-center px-6 sm:px-8 py-3 sm:py-4 bg-white/10 backdrop-blur-sm text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-orange-500 transition-all duration-300 border border-white/30 hover:border-orange-500 whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
                <i className="ri-mail-line ml-2"></i>
              </a>
            </div>
          </div>

          {/* Right Content - Camera Image */}
          <div className="relative hidden lg:flex items-center justify-center mt-8 lg:mt-0">
            <div className="relative w-full max-w-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/647e6d84-a84f-42bd-9ad4-97f44eb0978f.png"
                alt="業務用ビデオカメラ"
                className="w-full h-auto object-contain drop-shadow-2xl scale-[1.5]"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center text-white animate-bounce">
          <span className="text-xs sm:text-sm mb-2">Scroll</span>
          <i className="ri-arrow-down-line text-xl sm:text-2xl"></i>
        </div>
      </div>
    </section>
  );
}